export default {
    home:'ماڵ',
    gallery:'تایەر',
    files:'فایلەکان',
    file:'فایل',
    download:'بارکردن',
    downloads:'داگرتنەکان',
    music:'مۆسیقا',
    videos:'مقاطع فيديو',
    books:'كتب',
    settings:'ڕێکبەندەکان',
    games:'یاریەکان',
    categories:'بەشەکان',
    search_placeholder:'گەڕان: فایل، مۆسیقا، ڤیدیۆ، ئەندام و زیاتر.',
    theme:'دیزاین',
    language:'زمان',
    darkmode:'دۆخی تاریک',
    lightmode:'مۆدی کاڵ',
}